import {
  initializeLiteSharedArtColors,
  initializeLiteSharedArts,
  initializeLiteTextColors,
  initializeSharedArtColors,
} from './actions';

import { createReducer } from '@reduxjs/toolkit';

export const sharedArtColorsDict = createReducer({}, (builder) => {
  builder.addCase(initializeSharedArtColors, (state, action) => {
    const color = action.payload.color;
    const imprintAreaKey = action.payload.imprintAreaKey;
    state[imprintAreaKey] = state[imprintAreaKey] || {};
    state[imprintAreaKey] = color;
  });
});
export const liteSharedArtsDict = createReducer({}, (builder) => {
  builder.addCase(initializeLiteSharedArts, (state, action) => action.payload);
});

export const liteSharedArtColorsDict = createReducer({}, (builder) => {
  builder.addCase(initializeLiteSharedArtColors, (state, action) => action.payload);
});

export const liteTextColorsDict = createReducer({}, (builder) => {
  builder.addCase(initializeLiteTextColors, (state, action) => action.payload);
});
